import { Component, inject, Input, signal } from '@angular/core';
import { IImage } from '@web-nx-ng-tsc/web-shared-data-access';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-news-detail',
  standalone: true,
  imports: [],
  templateUrl: './lib-news-detail.component.html',
  styleUrl: './lib-news-detail.component.scss',
})
export class LibNewsDetailComponent {
  @Input() set data(value: IImage) {
    this.dataSignal.set(value);
    this.loggingService.log('dataSignal => ', value);
  }

  private readonly domSanitizer = inject(DomSanitizer);
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<IImage>({
    img: '',
    title: '',
    contentHTML: '',
    seoPageTitle: '',
    seoMetaDescription: '',
    seoUrl: '',
  });

  getSafeHtml(htmlString: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
